// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__3e20u","list":"BBPicture_list__1Jw9Z","firstItemBold":"BBPicture_firstItemBold__VvuD1","link":"BBPicture_link__LzK6H"};